import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-change-subscription-modal",
  templateUrl: "./change-subscription-modal.component.html",
  styleUrls: ["./change-subscription-modal.component.scss"],
})
export class ChangeSubscriptionModalComponent {
  @Input() fromSubject = "";
  @Input() toSubject = "";

  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.ChangeSubscription;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit() {
    this._modalService.closeModal();
    this.submit.emit();
  }
}
